import { AuthProviderProps } from 'react-oidc-context';

const rawClientId = process.env.REACT_APP_OIDC_CLIENT_ID;
const rawAuthority = process.env.REACT_APP_OIDC_AUTHORITY;

const clientId = typeof rawClientId === 'string' ? rawClientId.trim() : '';
const authority = typeof rawAuthority === 'string' ? rawAuthority.trim() : '';

function failConfig(message: string): never {
  throw new Error(`OIDC configuration error: ${message}`);
}

if (!clientId || clientId === 'undefined') {
  failConfig(
    'REACT_APP_OIDC_CLIENT_ID is not set or is invalid. Set the env var at build time.'
  );
}

if (!authority || authority === 'undefined') {
  failConfig(
    'REACT_APP_OIDC_AUTHORITY is not set or is invalid. Set the env var at build time.'
  );
}

export const oidcConfig: AuthProviderProps = {
  authority,
  client_id: clientId,
  redirect_uri: window.location.origin + '/home',
  post_logout_redirect_uri: window.location.origin + '/',
  scope: 'openid profile email',
};
